import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './SideBar.css';
import { SidebarContext } from './SidebarContext';
import { useUnsavedChanges } from '../Context/UnSavedChangesContext';
import UnsavedChanges from '../Modals/UnsavedChanges';
import { menus } from '../../constants';

interface MenuState {
  [key: string]: boolean;
}

interface SubMenuState {
  [parent: string]: {
    [key: string]: boolean;
  };
}

const SideBar: React.FC = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [routeRole, setRouteRole] = useState(userInfo?.roles);
  const [menuState, setMenuState] = useState<MenuState>({});
  const [subMenuState, setSubMenuState] = useState<SubMenuState>({});
  const [toggleMenus, setToggleMenus] = useState(false);
  const { toggleMenu, openMenu } = useContext(SidebarContext);
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const {
    isSidebarCollapsed,
    toggleSidebar,
    selectedFilters,
    resetSelectedFilters,
  } = useContext(SidebarContext);

  const { isWatched, setIsWatched, paths, setPaths } = useUnsavedChanges();

  const [showModal, setShowModal] = useState(false);
  const [path, setPath] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const { hasUnsavedChanges, setHasUnsavedChanges } = useUnsavedChanges();
  const [nextRoute, setNextRoute] = useState<string | null>(null);

  const handleNavigate = (path: string) => {
    if (isWatched) {
      setPath(path);
      setShowModal(true);
    } else {
      navigate(path);
    }
  };

  const confirmNavigate = (path: string) => {
    setShowModal(false);
    setIsWatched(false);
    navigate(paths);
  };

  const cancelNavigation = () => {
    setShowModal(false);
    setIsWatched(true);
  };
  useEffect(() => {
    const updateMenuState = () => {
      const updatedMenuState: MenuState = {};
      const updatedSubMenuState: SubMenuState = {};

      const checkSubItems = (items: any[], parentLabel?: string): boolean => {
        let hasActive = false;

        items.forEach((item) => {
          let itemIsActive = false;

          if (item.subItems) {
            // Initialize parent menu state if it doesn't exist
            if (parentLabel) {
              updatedSubMenuState[parentLabel] =
                updatedSubMenuState[parentLabel] || {};
              updatedSubMenuState[parentLabel][item.label] = false;
            } else {
              updatedMenuState[item.label] = false;
              updatedSubMenuState[item.label] = {};
            }

            // Check if any subitem matches current path
            const hasActiveChild = checkSubItems(item.subItems, item.label);
            itemIsActive = hasActiveChild;

            if (hasActiveChild) {
              if (parentLabel) {
                updatedSubMenuState[parentLabel][item.label] = true;
              } else {
                updatedMenuState[item.label] = true;
              }
            }
          }

          // Check if current item matches path
          if (
            item.to &&
            (item.to === currentPath || currentPath.startsWith(item.to + '/'))
          ) {
            itemIsActive = true;
            if (parentLabel) {
              updatedSubMenuState[parentLabel] =
                updatedSubMenuState[parentLabel] || {};
              updatedSubMenuState[parentLabel][item.label] = true;
            } else {
              updatedMenuState[item.label] = true;
            }
          }

          if (itemIsActive) {
            hasActive = true;
          }
        });

        return hasActive;
      };

      menus.forEach((menu) => {
        checkSubItems(menu.items);
      });

      setMenuState(updatedMenuState);
      setSubMenuState(updatedSubMenuState);
    };

    updateMenuState();
  }, [currentPath]);

  const handleMenuClick = () => {
    openMenu();
  };

  const hideAllMenusExcept = (menu: string) => {
    const newMenuState: MenuState = {};
    Object.keys(menuState).forEach((key) => {
      newMenuState[key] = key === menu;
    });

    setMenuState(newMenuState);
    if (hasUnsavedChanges) {
      setShowPopup(true);
      setNextRoute(menu);
    } else {
      navigate(menu);
    }
    resetSelectedFilters();
    if (isSidebarCollapsed) {
      toggleSidebar();
    }
  };

  const toggleMenuState = (menu: string, parentMenu?: string) => {
    if (parentMenu) {
      setSubMenuState((prevState) => ({
        ...prevState,
        [parentMenu]: {
          ...prevState[parentMenu],
          [menu]: !prevState[parentMenu]?.[menu],
        },
      }));
    } else {
      setMenuState((prevState) => ({
        ...prevState,
        [menu]: !prevState[menu],
      }));
    }

    setToggleMenus(false);
    if (isSidebarCollapsed) {
      toggleSidebar();
    }
  };

  const isMenuOpen = (menu: string) => !!menuState[menu];
  const isSubMenuOpen = (parentMenu: string, subMenu: string) =>
    !!subMenuState[parentMenu]?.[subMenu];

  const isActiveRoute = (section: string) => {
    return (
      currentPath === section ||
      currentPath.startsWith(`${section}/`) ||
      (section !== '/' && currentPath.includes(section))
    );
  };

  const gotoDashBoard = () => {
    // navigate("/portals/dashboard");
  };

  const handleNavigation = (route: string) => {
    if (hasUnsavedChanges) {
      setShowPopup(true);
      setNextRoute(route);
      setHasUnsavedChanges(false);
    } else {
      navigate(route);
      setHasUnsavedChanges(false);
    }
  };

  const confirmNavigation = () => {
    setShowPopup(false);
    if (nextRoute) {
      navigate(nextRoute);
    }
    setHasUnsavedChanges(false);
  };

  const checkNestedActive = (subItems: any[]): boolean => {
    return subItems.some((subItem) => {
      if (isActiveRoute(subItem.to)) {
        return true;
      }

      if (subItem.subItems) {
        return checkNestedActive(subItem.subItems);
      }

      return false;
    });
  };

  const renderMenuItems = (
    items: any[],
    parentMenu?: string,
    grandParentMenu?: string
  ) => {
    if (isSidebarCollapsed) {
      // toggleSidebar();
    }
    return items.map((item) => {
      localStorage.removeItem('leadData');
      if (item.subItems) {
        const isAnySubItemActive = checkNestedActive(item.subItems);
        const isOpen = parentMenu
          ? isSubMenuOpen(parentMenu, item.label)
          : isMenuOpen(item.label);

        return (
          <React.Fragment key={item.label}>
            <li
              className={`treeview nav-item cursor-pointer list-none px-3 ${
                isAnySubItemActive ? 'bg-[#FFF7F7]' : ''
              }`}
            >
              <a
                className={`nav-link justify-between items-center ${
                  isAnySubItemActive ? 'text-[#B00A2B]' : ''
                } ${isSidebarCollapsed ? 'block' : 'flex'}`}
                onClick={() => {
                  if (item.to?.includes('createPost')) {
                    handleNavigate(item.to);
                    return;
                  }
                  toggleMenuState(item.label, parentMenu);
                }}
              >
                <span className='text-base flex items-center'>
                  <img
                    src={isAnySubItemActive ? item?.activeImg : item?.img}
                    className='mr-2 '
                  />
                  {!isSidebarCollapsed && <>{item.label}</>}
                </span>
                {!isSidebarCollapsed && item.subItems && (
                  <span>
                    {!isOpen && (
                      <img
                        className='size-6 rotate-[0deg]'
                        src='/images/rightIcon.svg'
                      />
                    )}
                    {isOpen && (
                      <img
                        className='size-6 rotate-[180deg]'
                        src='/images/rightIcon.svg'
                      />
                    )}
                  </span>
                )}
              </a>
            </li>
            <ul
              className={`treeview-menu ${
                isOpen && !isSidebarCollapsed ? 'block' : 'hidden'
              }`}
            >
              {renderMenuItems(item.subItems, item.label, parentMenu)}
            </ul>
          </React.Fragment>
        );
      }

      return (
        <li
          className={`treeview nav-item cursor-pointer list-none p-1.5 ${
            isActiveRoute(item.to) ? 'active' : ''
          }`}
          key={item.to}
          onClick={() => {
            const currentPath = location.pathname;
            const targetPath = item.to;

            const isOnCreatePost = currentPath?.includes('createPost');
            const isOnAddEvents = currentPath?.includes('addEvents');
            const isGoingToCreatePost = targetPath?.includes('createPost');
            const isGoingToAddEvents = targetPath?.includes('addEvents');

            const navigatingBetweenSpecialPages =
              (isOnCreatePost && isGoingToAddEvents) ||
              (isOnAddEvents && isGoingToCreatePost);

            const isSameSpecialPage =
              (isOnCreatePost && isGoingToCreatePost) ||
              (isOnAddEvents && isGoingToAddEvents);

            const shouldNavigate =
              navigatingBetweenSpecialPages || !isSameSpecialPage;

            if (shouldNavigate) {
              handleNavigate(targetPath);
            }

            setPaths(targetPath);

            if (!isWatched) {
              hideAllMenusExcept(targetPath);
            }
          }}
        >
          <a className='nav-link' onClick={handleMenuClick}>
            <span className='text-gray-500 lg:text-base whitespace-nowrap flex font-medium items-center'>
              <img
                src={isActiveRoute(item.to) ? item?.activeImg : item?.img}
                className='mr-2'
              />
              {!isSidebarCollapsed && <>{item.label}</>}
            </span>
          </a>
        </li>
      );
    });
  };

  return (
    <div
      className={`mainSidebar h-screen bg-white text-center z-10 fixed transition-transform duration-300 ${
        toggleMenu ? 'translate-x-0' : '-translate-x-full'
      } w-inherit sm:translate-x-0 sm:w-64 lg:w-[16.6rem] md:w-[20.6rem] max-[1920px]:w-[20.6rem] w-[16rem] scroolCls overflow-y-scroll`}
    >
      <section className='sidebar'>
        <div className='flex align-center p-2 justify-center'>
          <span
            className='flex justify-center items-center mt-6'
            onClick={gotoDashBoard}
          >
            <div>
              <span
                className='gradient-text'
                style={{ color: '#ffffffde', marginLeft: '' }}
              >
                {!isSidebarCollapsed && <>FertilityIn </>}
              </span>
            </div>
          </span>
          <span
            className='mt-[10px] text-white text-xl cursor-pointer sm:hidden'
            onClick={openMenu}
          >
            X
          </span>
        </div>
        <ul className='sidebar-menu tree m-5 text-left' data-widget='tree'>
          {menus
            .filter((menu) => menu.role === routeRole)
            .map((menu) => renderMenuItems(menu.items))}
        </ul>
      </section>
      {showModal && (
        <UnsavedChanges
          confirmYes={() => confirmNavigate(paths)}
          stayHere={cancelNavigation}
        />
      )}
    </div>
  );
};

export default SideBar;
